import NoSsr from '@material-ui/core/NoSsr'
import { StoryblokComponent } from '@sb-konzept/gatsby-source-storyblok'
import FullScreenLoader from 'components/FullScreenLoader'
import PageContext from 'components/PageContext'
import PageLayout from 'components/PageLayout'
import { graphql } from 'gatsby'
import * as R from 'ramda'
import React, { Suspense, useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet'

import jumpTo from '../utils/jumpTo'
import {
  createStandortDescription,
  createStandortTitle
} from '../utils/standortDescriptions'

// Custom loader scrolls to anchor
const CustomLoader = () => {
  useEffect(() => () => jumpTo('berichte'))
  return <FullScreenLoader />
}

function DojoBerichte(props) {
  const { data, pageContext } = props

  const {
    page: {
      content: { body, layout }
    },
    siteInfo
  } = data

  // Defensive check for missing siteInfo
  if (!siteInfo) {
    console.error(`Missing siteInfo for page: ${pageContext?.siteInfo}`)
    return (
      <PageLayout>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Seite nicht verfügbar</h1>
          <p>Die Standortinformationen konnten nicht geladen werden.</p>
        </div>
      </PageLayout>
    )
  }

  const {
    content: { location }
  } = siteInfo

  const { header, footer } = useMemo(
    () =>
      R.applySpec({
        header: R.pathOr(null, [0, 'content', 'header', 0]),
        footer: R.pathOr(null, [0, 'content', 'footer', 0])
      })(layout),
    [layout]
  )

  useEffect(() => jumpTo('berichte'), [])

  return (
    <PageContext.Provider value={{ page: data.page }}>
      {header && <StoryblokComponent content={header} />}
      <Helmet>
        <title>{createStandortTitle(location, 'Berichte')}</title>
        <meta
          content={createStandortDescription(location, 'Berichte')}
          name="description"
        />
      </Helmet>

      <PageLayout>
        <NoSsr>
          <Suspense fallback={<CustomLoader />}>
            {siteInfo.content && (
              <StoryblokComponent content={siteInfo.content} />
            )}
            <StoryblokComponent content={data.page.content} />
          </Suspense>
        </NoSsr>
      </PageLayout>

      {footer && <StoryblokComponent content={footer} />}
    </PageContext.Provider>
  )
}

export default DojoBerichte

export const pageQuery = graphql`
  query($id: String!, $siteInfo: String!) {
    page: storyblokDojoBerichteStory(id: { eq: $id }) {
      ...storyblokDojoBerichteStory
    }
    siteInfo: storyblokDojoSiteInfoStory(full_slug: { eq: $siteInfo }) {
      ...storyblokDojoSiteInfoStory
    }
  }
`